import { render, staticRenderFns } from "./TableBlueLabelAction.vue?vue&type=template&id=416dd5c1&scoped=true&"
import script from "./TableBlueLabelAction.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelAction.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelAction.vue?vue&type=style&index=0&id=416dd5c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416dd5c1",
  null
  
)

export default component.exports